import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock, Mail } from 'lucide-react';
import { toast } from 'sonner';

// Dynamically determine API base URL
const getApiBase = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim() !== '') {
    return `${envUrl}/api`;
  }
  return '/api';
};

const API = getApiBase();

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      localStorage.setItem('admin_token', response.data.access_token);
      toast.success('Succesvol ingelogd!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Ongeldige inloggegevens');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        {/* Logo Section with white background */}
        <div className="text-center mb-8">
          <div className="inline-block bg-white rounded-2xl p-6 mb-6 shadow-lg">
            <img src="/logo.png" alt="Vanden Heede Logo" className="h-16 w-auto mx-auto" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins' }}>Admin Login</h1>
          <p className="text-gray-400 text-sm">Toegang tot het CMS Dashboard</p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-sm font-semibold mb-2 text-gray-700">E-mailadres</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="form-input"
                  style={{ paddingLeft: '48px' }}
                  placeholder="admin@voorbeeld.be"
                  required
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div className="mb-8">
              <label className="block text-sm font-semibold mb-2 text-gray-700">Wachtwoord</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="form-input"
                  style={{ paddingLeft: '48px' }}
                  placeholder="••••••••"
                  required
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn-primary w-full"
              disabled={loading}
              data-testid="admin-login-btn"
            >
              {loading ? 'Inloggen...' : 'Inloggen'}
            </button>
          </form>
        </div>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate('/')}
            className="text-gray-400 hover:text-white transition-colors text-sm"
            data-testid="back-to-site-btn"
          >
            ← Terug naar website
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;